import { useEffect, useRef, useState } from "react";
import Select from "../../../components/form/select/Select";
import { useFormik } from "formik";
import * as yup from "yup";
import { useSelector } from "react-redux";
import { getUserCustomers, resetTransfer, transferCustomer } from "../../../redux/slice/user/userSlice";
import { useDispatch } from "react-redux";

const sortUsersByOffice = (office_id, users,) => {
    return users
      ?.filter((item) => parseInt(item?.office_id) === office_id)
      ?.map((item) => ({
        label: item?.last_name + " " + item?.first_name,
        value: item?.staff_id,
    }));
};
const TransferCustomer = ({customers, state, office_id, setCustomers}) => {

    const dispatch = useDispatch();

    const close = useRef();

    const [sortedUsers, setSortedUsers] = useState([]);
    const [hasSelected, setHasSelected] = useState(false);

    const agentCusRef = useRef();
    const individualOffFilter = useRef();
    

    const { offices: { offices }, } = useSelector((state) => state.office);
    const { unpaginated_users, isTransferred } = useSelector((state) => state?.user); 

    const {
        errors,
        values,
        touched,
        handleBlur,
        handleSubmit,
        setFieldValue,
        setFieldError,
      } = useFormik({
        enableReinitialize: true,
        initialValues: {
          office_id: parseInt(office_id) ,
          staff_id: "",
        },
        validationSchema: () =>
          yup.object().shape({
            office_id: yup.number().required("Office is required"),
            staff_id: yup.string().required("Agent is required"),
          }),
        onSubmit: (values) => {
            if (!values.staff_id) {
                setFieldError("staff_id", "Agent is required");
                return;
            }

            const payload = {
                staff_id: values.staff_id,
                office_id: values.office_id,
                customers: customers,
            }
            dispatch(transferCustomer(payload));
        },
    });

    useEffect(() => {
        agentCusRef?.current?.clearValue();
        if (values?.office_id) {
          let sortedUsers = sortUsersByOffice(values?.office_id, unpaginated_users);
          setSortedUsers(sortedUsers);
        } else {
          setSortedUsers([]);
        }
    }, [values?.office_id, unpaginated_users]);

    useEffect(() => {
        if (isTransferred) {
            setFieldValue("staff_id", "");
            setFieldValue("office_id", office_id);
            dispatch(resetTransfer())
            close.current.click();
            setCustomers([]);
            dispatch(getUserCustomers({ id: state, searchBy: "" }));   
            setHasSelected(false);
        }
    }, [dispatch, isTransferred, office_id, setCustomers, setFieldValue, state]);


  return (
    <div>
        <div className='modal-header'>
            <h4 className='modal-title text-primary-1' id='myLargeModalLabel'>
            Transfer to:
            </h4>
            <span
            type='button'
            className='bg-gray hover rounded-circle border-none'
            data-bs-dismiss='modal'
            aria-hidden='true'
            ref={close}
            onClick={() => {
                setFieldValue("staff_id", "");
                setFieldValue("office_id", office_id);
                setHasSelected(false);
            }}
            style={{ padding: "0px 3px" }}
            >
            <i
                className='mdi mdi-close text-white'
                style={{ fontSize: "16px" }}
            ></i>
            </span>
        </div>
        <div className='modal-body'>
            <form onSubmit={handleSubmit}>
                <div className='row'>
                    <div className='col-sm-12'>
                        <label htmlFor='account_type' className={`form-label mt-1`}>
                        Office <span className='text-danger'>*</span>
                        </label>
                    </div>
    
                    <div className='col-sm-12'>
                        <Select
                        onBlur={() => {
                            handleBlur({ target: { name: "office_id" } });
                        }}
                        ref={individualOffFilter}
                        name='office_id'
                        data={offices?.map((item, i) => ({
                            label: item?.office_name,
                            value: item?.id,
                        }))}
                        value={parseInt(values?.office_id)}
                        onChange={(selectedOption) => {
                            setFieldValue("office_id", selectedOption?.value);
                        }}
                        />
                        {errors?.office_id && touched?.office_id && (
                        <p className='mb-0 text-danger'>
                            {errors?.office_id + "*"}
                        </p>
                        )}
                    </div>
                </div>
                <div className='row mt-2'>
                    <div className='col-sm-12 '>
                        <label htmlFor='account_type' className={`form-label mt-1`}>
                        Agent <span className='text-danger'>*</span>
                        </label>
                    </div>
                    <div className='col-sm-12'>
                        <Select
                            onBlur={() => {
                                handleBlur({ target: { name: "staff_id" } });
                            }}
                            name='staff_id'
                            ref={agentCusRef}
                            data={
                                sortedUsers
                            }
                            onChange={(selectedOption) => {
                                setFieldValue("staff_id", selectedOption?.value);
                                setHasSelected(true);
                            }}
                        // isLoading={unpaginated_users.length > 0 ? false : true}
                        />
                        {errors?.staff_id && !hasSelected && (
                            <p className="mb-0 text-danger">{errors?.staff_id}*</p>
                        )}
                        <div className='d-flex align-items-center justify-content-end gap-2 mt-3'>
                            <button type='submit' className='btn btn-sm btn-primary ' disabled={!values.office_id || !values.staff_id}>
                                Transfer
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
  )
}

export default TransferCustomer